var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMeatball(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.6925 24.692C23.3102 24.692 23.0002 24.382 23.0002 23.9997C23.0002 23.6174 23.3102 23.3074 23.6925 23.3074C24.0748 23.3074 24.3848 23.6174 24.3848 23.9997C24.3848 24.382 24.0748 24.692 23.6925 24.692Z",
    fill: "#262121",
    stroke: "#262121",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23.6925 32.9994C23.3102 32.9994 23.0002 32.6893 23.0002 32.3071C23.0002 31.9248 23.3102 31.6147 23.6925 31.6147C24.0748 31.6147 24.3848 31.9248 24.3848 32.3071C24.3848 32.6893 24.0748 32.9994 23.6925 32.9994Z",
    fill: "#262121",
    stroke: "#262121",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M23.6925 16.3846C23.3102 16.3846 23.0002 16.0747 23.0002 15.6923C23.0002 15.31 23.3102 15 23.6925 15C24.0748 15 24.3848 15.31 24.3848 15.6923C24.3848 16.0747 24.0748 16.3846 23.6925 16.3846Z",
    fill: "#262121",
    stroke: "#262121",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMeatball);
export default __webpack_public_path__ + "static/media/meatball.f0c71995967044517ae358a833fc085f.svg";
export { ForwardRef as ReactComponent };